import { supabase } from '../../supabaseClient';
import { supabaseGetEnvValue } from './supabaseGetEnvValue';
import reportError from '../error-handler/reportError';

async function supabaseCreateCheckoutSession(stripePayload) {
  try {
    const requestPayload = supabaseGetEnvValue();
    const result = await supabase.rpc('bn_get_stripe_checkout_session', { request_payload: { ...requestPayload, stripePayload } });
    if (!result.error) {
      return result.data;
    }
    return null;
  } catch (error) {
    console.error('Error getting stripe checkout session:', error.message);
    reportError(error);
  }
}

export { supabaseCreateCheckoutSession };
